__turbopack_context__.v({
  "triggerButton": "styles-module__pLIYca__triggerButton",
  "triggerIcon": "styles-module__pLIYca__triggerIcon",
  "wrapper": "styles-module__pLIYca__wrapper",
});
